import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Card,
  Checkbox,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import ListSubheader from "@mui/material/ListSubheader";
import Radio from "@mui/material/Radio";
import { useForm, Controller } from "react-hook-form";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
  useQuery,
  useManualQuery,
  useMutation,
  ClientContext,
} from "graphql-hooks";

import { MEMBER_TERM_EVENT_ATTENDANCE } from "../../graphQL/member";
import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const useStyles = makeStyles((theme) => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 30,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
  selectStyle: {
    minWidth: 350,
    height: 35,
    //  paddingLeft: 16,
    marginBottom: 10,
    "& .MuiOutlinedInput-input": {
      textAlign: "left",
    },
  },
  dataGridStyle: {
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#99D4FF",
      color: "#0D47A1",
    },

    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 14,
    },
  },
  card: {
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    padding: "20px",
    minHeight: "300px",
    borderRadius: "8px",
  },
}));

export default function MemberAttendanceInfoDialog({
  closeDialog,
  teamTerm,
  teamTermPeriodEvents,
  membersList,
  staffList,
}) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [loadData, setLoadData] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState({});
  const [members, setMembers] = useState(membersList);
  const [staff, setStaff] = useState(staffList);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set time to 00:00:00 to compare only the date part
  let clientId = 1;
  if (localStorage.getItem("clientId"))
    clientId = localStorage.getItem("clientId");
  let clientName = "";
  if (localStorage.getItem("clientName"))
    clientName = localStorage.getItem("clientName");
  let tenantId = 1;
  if (localStorage.getItem("tenantId"))
    tenantId = localStorage.getItem("tenantId");

  const [getMemberTermEventAttendanceQuery] = useManualQuery(
    MEMBER_TERM_EVENT_ATTENDANCE
  );

  const handleChangeValue = async (event) => {
    const data = event.target.value;
    for (const member of members) {
      member["currentEventAttendance"] = false;
      if (data && data.teamTermEventId && member.teamTermMemberId) {
        const {
          loading: loadingAttendanceData,
          error: errorAttendanceData,
          data: attendanceData,
        } = await getMemberTermEventAttendanceQuery({
          variables: {
            teamTermMemberId: parseInt(member.teamTermMemberId),
            teamTermEventId: parseInt(data.teamTermEventId),
          },
        });
      
        if (!loadingAttendanceData && 
          attendanceData &&
          attendanceData.getMemberTermEventAttendance) {
          member["currentEventAttendance"] = 
            attendanceData.getMemberTermEventAttendance
            ? attendanceData.getMemberTermEventAttendance
            : false;
        }
        if (errorAttendanceData) {
          member["currentEventAttendance"] = false;
          if (errorAttendanceData.graphQLErrors[0].message === "Signature has expired")
            navigate(`${project_url}/signin/?next=${pathname}`);
        }                      
      };
    };
    setMembers(members);

    for (const stff of staff) {
      stff["currentEventAttendance"] = false;
      if (data && data.teamTermEventId && stff.teamTermMemberId) {
        const {
          loading: loadingAttendanceData,
          error: errorAttendanceData,
          data: attendanceData,
        } = await getMemberTermEventAttendanceQuery({
          variables: {
            teamTermMemberId: parseInt(stff.teamTermMemberId),
            teamTermEventId: parseInt(data.teamTermEventId),
          },
        });
      
        if (!loadingAttendanceData && 
          attendanceData &&
          attendanceData.getMemberTermEventAttendance) {
          stff["currentEventAttendance"] = 
            attendanceData.getMemberTermEventAttendance.attended
            ? attendanceData.getMemberTermEventAttendance.attended
            : false;
        }
        if (errorAttendanceData) {
          stff["currentEventAttendance"] = false;
          if (errorAttendanceData.graphQLErrors[0].message === "Signature has expired")
            navigate(`${project_url}/signin/?next=${pathname}`);
        }                     
      };
    };
    setStaff(staff);
    data && setSelectedEvent(data);
  };  

  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };
  const dayFormat = (day) => {
    let newFormat = "-";
    if (day) {
      const dayDate = new Date(day);
      const dayFormat = formatter.formatToParts(dayDate);
      newFormat =
        dayFormat.find((a) => a.type == "month").value +
        "/" +
        dayFormat.find((a) => a.type == "day").value +
        "/" +
        dayFormat.find((a) => a.type == "year").value;
    }
    return newFormat;
  };

  useEffect(() => {
    handleChangeValue({ target: { value: teamTermPeriodEvents[0] } });
  }, [teamTerm, teamTermPeriodEvents]);

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  function CustomNoRowsOverlay() {
    return (
      <Box sx={{ mt: 2 }}>
        There is no event that requires any member's attendance
      </Box>
    );
  }  

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            maxWidth: "none",
          },
        }}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "800px",
              height: "100%",
              //minWidth: "600px",
              maxHeight: "700px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
        >
          <Box 
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'space-between' 
            }}
          >
            <Box sx={{ width: 40 }} />
            <Box mt={1} ml={1}
              sx={{ textAlign: 'center', flexGrow: 1 }}>
              Team Resources Attendance
            </Box>
            {closeDialog ? (
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{                  
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="h3"
            style={{ 
              fontSize: 16, 
              textAlign: "left", 
              marginBottom: 15,
              paddingLeft: 20, 
            }}
          >
            <b>Team: </b> {teamTerm}
          </Typography>
          <Box 
            style={{ 
              display: "flex", 
              flexDirection: "row",
              paddingLeft: 20, 
            }}
          >
            <Typography
              variant="h3"
              style={{
                fontSize: 16,
                textAlign: "left",
                marginBottom: 5,
                paddingTop: 5,
              }}
            >
              <b>Event:</b>
            </Typography>
            <Box pl={1}>
              <Select
                className={classes.selectStyle}
                defaultValue={teamTermPeriodEvents[0]}
                margin="normal"
                onChange={handleChangeValue}
              >              
                {teamTermPeriodEvents.map((event, index) => (
                  <MenuItem key={index} value={event}>
                    {event.period} : {event.event}
                  </MenuItem>
                ))}                
              </Select>
            </Box>            
          </Box>
          {Object.keys(selectedEvent).length !== 0 ? (
            <Typography
              variant="h3"
              style={{ 
                fontSize: 16, 
                textAlign: "left", 
                marginBottom: 15,
                paddingLeft: 20
              }}
            >
              <b>Actual Date: </b>
              {`${selectedEvent.actualDate && dayFormat(selectedEvent.actualDate.substring(0, 10), "monthDDYYYY")}`}{" "}
              <span style={{ fontSize: 14 }}>
                (Scheduled Date: 
                {selectedEvent.scheduledDate && dayFormat(selectedEvent.scheduledDate.substring(0, 10), "monthDDYYYY")}
                )
              </span>             
            </Typography>
          ) : (
            <Typography
              variant="h3"
              style={{ 
                fontSize: 16, 
                textAlign: "left", 
                marginBottom: 15,
                paddingLeft: 20
              }}
            >
              <b>Actual Date: </b>--
            </Typography>
          )}
          <Grid
            container
            spacing={3}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              padding: "24px",
              paddingBottom:0,
              paddingTop: "4px",
            }}
          >
            <Grid item md={6}>
              <Card
                className={classes.card}
                style={{
                  maxWidth: "300px",
                  overflowY: "auto",
                }}
              >
                <Typography
                  variant="h4"
                  style={{
                    fontSize: 16,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Members
                </Typography>
                <Grid container alignItems="center">
                  <Grid item xs={5}>
                    <Typography variant="h4" style={{ paddingTop: 10 }}>
                      Name
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="h4" style={{ paddingTop: 10 }}>
                      Role
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography variant="h4" style={{ paddingTop: 10 }}>
                      Attended?
                    </Typography>
                  </Grid>
                </Grid>
                {members.map((item) => (
                  <>
                    <Grid container alignItems="center">
                      <Grid item xs={5}>
                        <Typography variant="h5" style={{ paddingTop: 10 }}>
                          {item.userId.firstName} {item.userId.lastName}
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="h5" style={{ paddingTop: 10 }}>
                          {item.roleId.roleName}
                        </Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography variant="h5" style={{ paddingTop: 10, textAlign:"center" }}>
                          {item.currentEventAttendance ? "Yes" : "No"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </>
                ))}
              </Card>
            </Grid>
            <Grid item md={6}>
              <Card
                className={classes.card}
                style={{
                  maxWidth: "300px",
                  overflowY: "auto",
                }}
              >
                <Typography
                  variant="h4"
                  style={{
                    fontSize: 16,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Staff
                </Typography>
                <Grid container alignItems="center">
                  <Grid item xs={5}>
                    <Typography variant="h4" style={{ paddingTop: 10 }}>
                      Name
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="h4" style={{ paddingTop: 10 }}>
                      Role
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography variant="h4" style={{ paddingTop: 10 }}>
                      Attended?
                    </Typography>
                  </Grid>
                </Grid>
                {staff.map((item) => (
                  <>
                    <Grid container alignItems="center">
                      <Grid item xs={5}>
                        <Typography variant="h5" style={{ paddingTop: 10 }}>
                          {item.userId.firstName} {item.userId.lastName}
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="h5" style={{ paddingTop: 10 }}>
                          {item.roleId.roleName}
                        </Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography variant="h5" style={{ paddingTop: 10, textAlign:"center" }}>
                          {item.currentEventAttendance ? "Yes" : "No"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </>
                ))}
              </Card>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 2 }}
              onClick={handleClose}
            >
              Done
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
